import { getHistoricalData } from "../workOrderService";


export const mapReportToPrintLog = (report) => {
  return {
    storeId: report.storeId,
    workOrderId: report.workOrderId,
    categories: report.categories,
    additionalNotes: report.additionalNotes
  }
}

export const mapPrintLogToReport = async (printLog) => {
  const historicalData = await getHistoricalData(printLog.license, printLog.state, printLog.storeId);
  const report = {
    storeId: printLog.storeId,
    workOrderId: printLog.workOrderId,
    phone: printLog.phone,
    customerId: printLog.customerId,
    odsCusomerId: printLog.odsCustomerId,
    source: printLog.woSource,
    vehicleDetails: {
      make: printLog.make,
      model: printLog.model,
      year: printLog.year,
      license: printLog.license,
      vehicleId: printLog.vehicleId,
      state: printLog.state,
    },
    printedDate: printLog.printedDt,
    ptscFlag: printLog.ptscFlag,
    lastVisitDate: historicalData?.lastVisit,
    categories: mapCategories(printLog.categories, historicalData?.historicalData),
    additionalNotes: printLog.additional_notes
  };
  return report;
}

const mapCategories = (categories, historicalData) => {
  try{
    categories = categories.map(category => {
          return {
              name: category.name,
              subCategories: mapSubcategories(category.subCategories),
              notes: category.notes,
              previousVisits: historicalData?.map(visit => {
                const values = visit.categories.filter((categoryVisit => categoryVisit.name === category.key))
                return {values: values}
              })
          }
      })
  }
  catch(e){
      console.log(e)
  }
  return categories;
}

const mapSubcategories = (subcategories) => {
  let subcategoriesArray = [];
  try {
    subcategories.map(subcat => {
      subcategoriesArray.push({name: subcat.name, value: subcat.value});
    })

    return subcategoriesArray;
  } catch (e) {
    console.log(e)
  }
}